module.exports = __webpack_public_path__ + "img/scuba_320.25d791ff.png";